function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "m0 6.174v5.926a1.3 1.3 0 0 0 1.3 1.3h11.4a1.3 1.3 0 0 0 1.3-1.3v-5.926a1.3 1.3 0 0 0 -.519-1.038l-5.701-4.277a1.3 1.3 0 0 0 -1.558 0l-5.703 4.277a1.3 1.3 0 0 0 -.519 1.038zm7 2.414-4.083-3.063 3.305-2.478a1.3 1.3 0 0 1 1.558 0l3.3 2.478z",
  fill: "currentColor",
  fillRule: "evenodd"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 14 14"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/list-filled.24fb0439.svg";
export { SvgComponent as ReactComponent };